import { render, staticRenderFns } from "./KeywordTitle.vue?vue&type=template&id=57c7bce2"
import script from "./KeywordTitle.vue?vue&type=script&lang=js"
export * from "./KeywordTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports